import httpClient from "../../../../shared/api/httpClient";
import { qs } from "../../../../shared/api/qs";

const base = "/hr/tasks/admin";

export const getTaskOptions = () => httpClient.get(`${base}/options`);
export const getTodayTasks = (filters = {}) => httpClient.get(`${base}/today${qs(filters)}`);
export const getTaskHistory = (filters) => httpClient.get(`${base}/history${qs(filters)}`);
export const getExecutionDetail = (id) => httpClient.get(`${base}/executions/${id}`);

export const getRoutines = () => httpClient.get(`${base}/routines`);
export const getRoutine = (id) => httpClient.get(`${base}/routines/${id}`);
export const createRoutine = (payload) => httpClient.post(`${base}/routines`, payload);
export const updateRoutine = (id, payload) => httpClient.patch(`${base}/routines/${id}`, payload);
export const deleteRoutine = (id) => httpClient.delete(`${base}/routines/${id}`);
export const createRoutineTask = (routineId, payload) => httpClient.post(`${base}/routines/${routineId}/tasks`, payload);
export const updateRoutineTask = (routineId, taskId, payload) => httpClient.patch(`${base}/routines/${routineId}/tasks/${taskId}`, payload);
export const deleteRoutineTask = (routineId, taskId) => httpClient.delete(`${base}/routines/${routineId}/tasks/${taskId}`);
export const reorderRoutineTasks = (routineId, items) => httpClient.put(`${base}/routines/${routineId}/tasks/order`, { items });

export const getOneOffVisibility = (filters) => httpClient.get(`${base}/one-off-visibility${qs(filters)}`);
export const createOneOff = (payload) => httpClient.post(`${base}/one-offs`, payload);
